import { toast } from "react-toastify";

const settings = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export const useToastInfo = () => {
  // Retornamos una función que aceptará el mensaje cuando se quiera mostrar
  return (message) => {
    toast.error(message, settings); // Mostramos el toast de error
  };
};
